import { Injectable } from "@angular/core";
import { ApiService } from "../provider/api.service";
import { endpoints } from "../constant/endpoints";
import moment from "moment";
import {
  CachedSubscriptionData,
  DayConfig,
} from "../daily-menu/daily-menu.interfaces";
import { SubscriptionDateService } from "./subscription-date.service";
import { CacheManagementService } from "./cache-management.service";
import { AuthService } from "./auth.service";
import { CustomerPreferencesService } from "./customer-preferences.service";

@Injectable({
  providedIn: "root",
})
export class DailyMenuDataService {
  private readonly PREFETCH_DAYS_ON_INIT = 3;
  private readonly PREFETCH_DAYS_ON_NAVIGATE = 2;

  private customerId: number = 0;
  private customerData: any = null;

  dummyData: any = {
    code: 200,
    success: true,
    message: "Menu Items",
    data: {
      allowed_meals: 3,
      allowed_snacks: 2,
      menu_builders: [
        {
          type_name: "Breakfast",
          a_type_name: "الفطور",
          food_type_id: "4",
          color_code: "#1f02f7",
          text_color_code: "#000000",
          type_data: [
            {
              id: 2962,
              menu_builder_id: 10151,
              food_type_category: "meal",
              food_type_id: 4,
              slug: "885C7",
              name: "Al Qudsi Foul",
              a_name: "فول قدسي",
              description: "Hearty Jerusalem-style seasoned fava beans",
              a_description: "فول القدس الشهي بالتوابل",
              maximum_selection_limit: 99999,
              scaled_protein: null,
              scaled_carbs: 0,
              display_order: 25,
              protein: 12,
              calories: 257,
              fats: 15,
              carbs: 36,
              fiber: 0,
              attachment:
                "https://foodna-assets.s3.ap-south-1.amazonaws.com/uploads/menu_items/7eb2d5871b13cfa43bcdd7faaa6e30ded0f3b248.jpg",
              is_active: true,
              is_selected: false,
              selected_menu_item_id: 0,
              quantity: 0,
              selection_number: 0,
              rating: 0,
              my_rating: 0,
              comment: "",
              is_rating_given: false,
              recipe_text: "",
              recipes: [
                {
                  id: 19465,
                  title: "FOUL MEDAMMES",
                  a_title: "فول مدمس",
                  measure_unit: "kilogram",
                  quantity: 0.1,
                  is_mandatory_for_menu_item: 1,
                },
                {
                  id: 19598,
                  title: "OLIVE OIL",
                  a_title: "زيت الزيتون",
                  measure_unit: "liter",
                  quantity: 0.01,
                  is_mandatory_for_menu_item: 0,
                  recipes: [
                    {
                      id: 8881,
                      title: "RAW OLIVES",
                      a_title: "زيتون خام",
                      measure_unit: "kilogram",
                      quantity: 0.5,
                      is_mandatory_for_menu_item: 0,
                    },
                  ],
                },
              ],
              show_confirmation_popup: false,
              replaceable_menu_items: [],
              is_customizations_available: 0,
              customizations: [],
              tags: [],
            },
            {
              id: 3474,
              menu_builder_id: 10152,
              food_type_category: "meal",
              food_type_id: 4,
              slug: "DFDE4",
              name: "Oatmeal Cottage Banana Pancake",
              a_name: "بان كيك الشوفان",
              description: "Wholesome Pancake",
              a_description: "فطيرة صحية",
              maximum_selection_limit: 99999,
              protein: 16.5,
              calories: 111,
              fats: 5.6,
              carbs: 14.9,
              attachment:
                "https://foodna-assets.s3.ap-south-1.amazonaws.com/uploads/menu_items/6b0cdacf44114d3345b138b14f5dd6621cee2a79.jpg",
              is_active: true,
              recipes: [
                {
                  id: 19473,
                  title: "FRESH BANANA",
                  a_title: "موز",
                  measure_unit: "kilogram",
                  quantity: 0.36,
                  is_mandatory_for_menu_item: 0,
                },
                {
                  id: 19837,
                  title: "BANANA FLAVOR ESSENSE",
                  a_title: "خلاصة نكهة الموز",
                  measure_unit: "liter",
                  quantity: 0.001,
                  is_mandatory_for_menu_item: 0,
                  recipes: [
                    {
                      id: 19674,
                      title: "WHITE FLOUR",
                      a_title: "دقيق أبيض",
                      measure_unit: "kilogram",
                      quantity: 0.04,
                      is_mandatory_for_menu_item: 0,
                    },
                    {
                      id: 19645,
                      title: "SUGAR",
                      a_title: "سكر",
                      measure_unit: "kilogram",
                      quantity: 0.005,
                      is_mandatory_for_menu_item: 0,
                    },
                  ],
                },
              ],
            },
            {
              id: 3240,
              menu_builder_id: 10153,
              food_type_category: "meal",
              food_type_id: 4,
              slug: "B0DCD",
              name: "Falafel Tahini Bagel",
              a_name: "بيغل الفلافل",
              description: "Falafel with tahini sauce",
              a_description: "فلافل مع صوص الطحينة",
              protein: 15,
              calories: 377,
              fats: 16,
              carbs: 47,
              attachment:
                "https://foodna-assets.s3.ap-south-1.amazonaws.com/uploads/menu_items/b8010d93ddc4929c181d2dd0f42157a5b32e29f7.jpg",
              is_active: true,
              recipes: [
                {
                  id: 7721,
                  title: "FALAFEL DOUGH",
                  a_title: "عجينة الفلافل",
                  measure_unit: "kilogram",
                  quantity: 0.15,
                  is_mandatory_for_menu_item: 1,
                  recipes: [
                    {
                      id: 19418,
                      title: "CHICK PEAS",
                      a_title: "حمص",
                      measure_unit: "kilogram",
                      quantity: 0.1,
                      is_mandatory_for_menu_item: 1,
                    },
                    {
                      id: 19490,
                      title: "FRESH GARLIC",
                      a_title: "الثوم الطازج",
                      measure_unit: "kilogram",
                      quantity: 0.005,
                      is_mandatory_for_menu_item: 0,
                    },
                  ],
                },
                {
                  id: 9901,
                  title: "TAHINI SAUCE",
                  a_title: "صوص طحينة",
                  measure_unit: "liter",
                  quantity: 0.03,
                  is_mandatory_for_menu_item: 0,
                },
              ],
            },
          ],
        },
      ],
    },
  };
  constructor(
    private apiService: ApiService,
    private subscriptionDateService: SubscriptionDateService,
    private cacheService: CacheManagementService,
    private authService: AuthService,
    private customerPreferencesService: CustomerPreferencesService,
  ) {}

  async initializeCache(customerId: number): Promise<void> {
    if (!customerId) return;

    this.customerId = customerId;

    // Ensure SubscriptionDateService is initialized
    const state = this.subscriptionDateService.getState();
    if (state.activeSubscriptions.length === 0 && state.lastUpdated === 0) {
      console.warn(
        "[DailyMenuDataService] SubscriptionDateService not initialized, initializing now",
      );
      await this.subscriptionDateService.initialize(customerId);
    }

    const currentState = this.subscriptionDateService.getState();
    console.log(
      "[DailyMenuDataService] Initialized with",
      currentState.activeSubscriptions.length,
      "subscriptions",
    );
  }

  async preloadInitialDays(customerId: number, customer: any): Promise<void> {
    console.log("[DailyMenuDataService] preloadInitialDays called", {
      customerId,
      hasCustomer: !!customer,
    });

    if (!customerId) {
      console.warn("[DailyMenuDataService] preloadInitialDays: No customerId");
      return;
    }

    const profileData = this.getProfileDataFromCache(customerId);
    if (profileData) {
      this.customerData = profileData;
      console.log(
        "[DailyMenuDataService] Using profile data with allergies/dislikes",
      );
    } else if (customer) {
      this.customerData = customer;
    }

    const state = this.subscriptionDateService.getState();
    const availableDates = state.availableDates;

    console.log("[DailyMenuDataService] preloadInitialDays state:", {
      availableDatesCount: availableDates.length,
      dayConfigsCount: Object.keys(state.dayConfigs).length,
    });

    if (availableDates.length === 0) {
      console.warn(
        "[DailyMenuDataService] preloadInitialDays: No available dates",
      );
      return;
    }

    const datesToPrefetch = availableDates.slice(0, this.PREFETCH_DAYS_ON_INIT);
    console.log(
      `📦 Preloading first ${
        datesToPrefetch.length
      } days: ${datesToPrefetch.join(", ")}`,
    );

    await this.preloadDatesSequentially(
      customerId,
      datesToPrefetch,
      this.customerData,
      state.dayConfigs,
    );
  }

  private getProfileDataFromCache(customerId: number): any {
    const profileUrl = `${endpoints.profile}?customer_id=${customerId}`;
    const cached = this.cacheService.get<any>(profileUrl, "data-service");
    return cached?.customer || null;
  }

  private async preloadDatesSequentially(
    customerId: number,
    dates: string[],
    customer: any,
    dayConfigs: { [date: string]: DayConfig },
  ): Promise<void> {
    for (const date of dates) {
      const dayConfig = dayConfigs[date];
      if (!dayConfig) continue;

      const selectionLimit = this.buildSelectionLimitMap(
        dayConfig.selectionLimit,
      );
      const isDoubleBox = dayConfig.isDoubleBox;
      const cacheKey = this.getCacheKey(date, false);

      const cached = this.cacheService.get<any>(cacheKey, "daily-menu");
      if (!cached || !cached.newNestedArray) {
        console.log(`[DailyMenuDataService] Preloading ${cacheKey}`);
        await this.cacheService
          .getOrFetch(
            cacheKey,
            "daily-menu",
            () =>
              this.fetchAndProcessMenu(
                customerId,
                date,
                false,
                customer,
                selectionLimit,
                cacheKey,
              ),
            { silent: true },
          )
          .catch(() => {});
      } else {
        console.log(
          `[DailyMenuDataService] Skip preload ${cacheKey} - already cached`,
        );
      }

      if (isDoubleBox) {
        const box2Key = this.getCacheKey(date, true);
        const box2Cached = this.cacheService.get<any>(box2Key, "daily-menu");
        if (!box2Cached || !box2Cached.newNestedArray) {
          console.log(`[DailyMenuDataService] Preloading ${box2Key}`);
          await this.cacheService
            .getOrFetch(
              box2Key,
              "daily-menu",
              () =>
                this.fetchAndProcessMenu(
                  customerId,
                  date,
                  true,
                  customer,
                  selectionLimit,
                  box2Key,
                ),
              { silent: true },
            )
            .catch(() => {});
        }
      }
    }
  }

  private buildSelectionLimitMap(selectionLimitData: any): {
    [foodTypeId: number]: number;
  } {
    const map: { [foodTypeId: number]: number } = {};
    if (!selectionLimitData) return map;
    if (
      typeof selectionLimitData === "object" &&
      !Array.isArray(selectionLimitData)
    )
      return selectionLimitData;
    if (Array.isArray(selectionLimitData)) {
      selectionLimitData.forEach((item: any) => {
        if (item.food_type_id && item.limit)
          map[item.food_type_id] = item.limit;
      });
    }
    return map;
  }

  clearCache(): void {
    this.cacheService.clear("daily-menu");
    this.customerId = 0;
  }

  invalidateCacheForCustomer(): void {
    this.cacheService.clear("daily-menu");
  }

  async getMenuData(
    customerId: number,
    date: string,
    isDoubleBox: boolean,
    customer: any,
    selectionLimit: any,
  ): Promise<any> {
    if (!customerId || !date) {
      console.warn("[DailyMenuDataService] Missing customerId or date");
      return { newNestedArray: [] };
    }

    if (customer) {
      this.customerData = customer;
    }

    const cacheKey = this.getCacheKey(date, isDoubleBox);
    const cached = this.cacheService.get<any>(cacheKey, "daily-menu");

    if (cached && cached.newNestedArray) {
      console.log(`[DailyMenuDataService] Cache HIT for ${cacheKey}`);
      return cached;
    }

    console.log(
      `[DailyMenuDataService] Cache MISS for ${cacheKey}, fetching from API`,
    );
    return this.cacheService
      .getOrFetch(
        cacheKey,
        "daily-menu",
        () =>
          this.fetchAndProcessMenu(
            customerId,
            date,
            isDoubleBox,
            customer || this.customerData,
            selectionLimit,
            cacheKey,
          ),
        { backgroundRefresh: false },
      )
      .then((result) => {
        return result || { newNestedArray: [] };
      });
  }

  private async fetchAndProcessMenu(
    customerId: number,
    date: string,
    isDoubleBox: boolean,
    customer: any,
    selectionLimit: any,
    cacheKey: string,
  ): Promise<any> {
    console.log(`[DailyMenuDataService] API CALL for ${cacheKey}`);

    try {
      await this.customerPreferencesService.loadPreferences(customerId);

      const menuData = await this.fetchMenuBuildersInternal(
        customerId,
        date,
        isDoubleBox,
      );

      if (!menuData || !Array.isArray(menuData) || menuData.length === 0) {
        const emptyResult = { newNestedArray: [] };
        this.cacheService.set(cacheKey, emptyResult, "daily-menu");
        return emptyResult;
      }

      const processed = this.processMenuApiResponse(
        menuData,
        customer || this.customerData,
        selectionLimit,
      );
      return processed;
    } catch (error) {
      console.error("[DailyMenuDataService] Error fetching menu data:", error);
      return { newNestedArray: [] };
    }
  }

  invalidateDate(date: string): void {
    const box1Key = this.getCacheKey(date, false);
    const box2Key = this.getCacheKey(date, true);
    this.cacheService.delete(box1Key, "daily-menu");
    this.cacheService.delete(box2Key, "daily-menu");
  }

  onLeavingDate(
    customerId: number,
    date: string,
    isDoubleBox: boolean,
    customer: any,
    selectionLimit: any,
  ): void {
    const cacheKey = this.getCacheKey(date, isDoubleBox);
    setTimeout(() => {
      this.cacheService
        .getOrFetch(
          cacheKey,
          "daily-menu",
          () =>
            this.fetchAndProcessMenu(
              customerId,
              date,
              isDoubleBox,
              customer,
              selectionLimit,
              cacheKey,
            ),
          { forceRefresh: true, silent: true },
        )
        .catch(() => {});
    }, 100);
  }

  preloadUpcomingDates(
    customerId: number,
    currentDate: string,
    customer: any,
  ): void {
    if (customer) {
      this.customerData = customer;
    }

    const state = this.subscriptionDateService.getState();
    const availableDates = state.availableDates;
    const currentIndex = availableDates.indexOf(currentDate);

    if (currentIndex === -1) return;

    const datesToPreload: string[] = [];
    for (
      let i = 1;
      i <= this.PREFETCH_DAYS_ON_NAVIGATE &&
      currentIndex + i < availableDates.length;
      i++
    ) {
      const nextDate = availableDates[currentIndex + i];
      const cacheKey = this.getCacheKey(nextDate, false);
      const cached = this.cacheService.get<any>(cacheKey, "daily-menu");
      if (!cached || !cached.newNestedArray) {
        datesToPreload.push(nextDate);
      }
    }

    if (datesToPreload.length === 0) {
      console.log(`[DailyMenuDataService] All upcoming dates already cached`);
      return;
    }

    console.log(
      `📦 Preloading next ${datesToPreload.length} days: ${datesToPreload.join(
        ", ",
      )}`,
    );

    setTimeout(() => {
      this.preloadDatesSequentially(
        customerId,
        datesToPreload,
        customer || this.customerData,
        state.dayConfigs,
      );
    }, 200);
  }

  /**
   * Preloads only the immediately adjacent dates (yesterday and tomorrow in availableDates)
   * during browser idle time so switching to the previous/next day feels instant.
   * Uses requestIdleCallback when available, with setTimeout fallback.
   */
  preloadAdjacentDatesIdle(
    customerId: number,
    currentDate: string,
    customer: any,
  ): void {
    if (customer) {
      this.customerData = customer;
    }

    const state = this.subscriptionDateService.getState();
    const availableDates = state.availableDates;
    const currentIndex = availableDates.indexOf(currentDate);

    if (currentIndex === -1) return;

    const datesToPreload: string[] = [];

    if (currentIndex > 0) {
      const prevDate = availableDates[currentIndex - 1];
      const prevKey = this.getCacheKey(prevDate, false);
      if (!this.cacheService.get<any>(prevKey, "daily-menu")?.newNestedArray) {
        datesToPreload.push(prevDate);
      }
    }

    if (currentIndex + 1 < availableDates.length) {
      const nextDate = availableDates[currentIndex + 1];
      const nextKey = this.getCacheKey(nextDate, false);
      if (!this.cacheService.get<any>(nextKey, "daily-menu")?.newNestedArray) {
        datesToPreload.push(nextDate);
      }
    }

    if (datesToPreload.length === 0) return;

    const runPreload = (): void => {
      this.preloadDatesSequentially(
        customerId,
        datesToPreload,
        customer || this.customerData,
        state.dayConfigs,
      );
    };

    const scheduleIdle = (): void => {
      if (typeof window === "undefined") return;
      const w = window as Window & {
        requestIdleCallback?: (
          cb: () => void,
          opts?: { timeout: number },
        ) => number;
      };
      if (typeof w.requestIdleCallback === "function") {
        w.requestIdleCallback(runPreload, { timeout: 2000 });
      } else {
        setTimeout(runPreload, 500);
      }
    };

    scheduleIdle();
  }

  getSubscriptionData(): CachedSubscriptionData {
    const state = this.subscriptionDateService.getState();
    return {
      subscriptions: state.activeSubscriptions,
      availableDates: state.availableDates,
      dayConfigMap: state.dayConfigs,
    };
  }

  async fetchMenuBuilders(
    customerId: number,
    date: string,
    isDoubleBox: boolean,
  ): Promise<any[] | null> {
    return await this.fetchMenuBuildersInternal(customerId, date, isDoubleBox);
  }

  processMenuApiResponse(
    response: any[],
    customer: any,
    selectionLimit: { [foodTypeId: number]: number },
  ): any {
    if (!response || !Array.isArray(response) || response.length === 0) {
      return { newNestedArray: [] };
    }
    // const newNestedArray = response
    const newNestedArray = response
      .map((builder: any) => {
        // Determine food type limit with proper priority
        let typeLimit = builder.type_limit;

        // Case 1: API explicitly provides a limit (even if 0)
        if (typeLimit !== undefined && typeLimit !== null) {
          // If API says 0, exclude this food type
          if (typeLimit === 0) {
            console.warn(
              `Food type ${builder.food_type_id} has explicit limit 0 - excluding from menu`,
            );
            return null;
          }
          // API provided a valid limit, use it
        } else {
          // Case 2: API doesn't provide limit, check selectionLimit map
          typeLimit = selectionLimit[builder.food_type_id];

          // Case 3: If still no limit, it means use category limit (don't exclude)
          // The category limit will be applied at validation time
          if (!typeLimit || typeLimit === 0) {
            // Don't exclude - category limit will apply
            typeLimit = null; // Mark as "use category limit"
          }
        }

        const transformedTypeData = (builder.type_data || []).map(
          (menuItem: any) => {
            const transformedReplaceableItems = (
              menuItem.replaceable_menu_items || []
            ).map((replaceable_item: any) => ({
              ...replaceable_item,
              type_name: builder.type_name,
              parent_id: menuItem.menu_builder_id,
              a_type_name: builder.a_type_name,
              food_type_id: builder.food_type_id,
              food_type_category: menuItem.food_type_category,
              quantity: replaceable_item.quantity || 0,
              is_selected: replaceable_item.is_selected || false,
              selection_number: replaceable_item.selection_number
                ? replaceable_item.selection_number
                : "",
              scaled_carbs: replaceable_item.carbs || 0,
            }));

            const isAnyReplacementSelected = transformedReplaceableItems.some(
              (item: { is_selected: any }) => item.is_selected,
            );

            return {
              ...menuItem,
              health_code:
                this.customerPreferencesService.checkMenuItemHealthCode(
                  menuItem.recipes,
                ),
              type_name: builder.type_name,
              a_type_name: builder.a_type_name,
              is_replaceable_selected: isAnyReplacementSelected,
              toggle_replaceable: isAnyReplacementSelected,
              food_type_id: builder.food_type_id,
              quantity: menuItem.quantity || 0,
              is_selected: menuItem.is_selected || false,
              selection_number: menuItem.selection_number
                ? menuItem.selection_number
                : "",
              scaled_carbs: menuItem.carbs || 0,
              replaceable_menu_items: transformedReplaceableItems,
            };
          },
        );

        const selectedQuantity = transformedTypeData.reduce(
          (total: any, item: any) => total + item.quantity,
          0,
        );

        return {
          ...builder,
          type_data: transformedTypeData,
          selected_quantity: selectedQuantity,
          type_limit: typeLimit, // Can be null if using category limit
        };
      })
      .filter((builder: any) => builder !== null);

    return { newNestedArray };
  }

  private getCacheKey(date: string, isDoubleBox: boolean): string {
    return `${date}_${isDoubleBox ? "box2" : "box1"}`;
  }

  private async fetchMenuBuildersInternal(
    customerId: number,
    date: string,
    isDoubleBox: boolean,
  ): Promise<any[] | null> {
    try {
      if (!customerId) {
        console.warn("[DailyMenuDataService] Customer ID not available");
        return null;
      }

      const isDoubleBoxParam = isDoubleBox.toString();
      const apiUrl = `menu_builders?date=${date}&is_double_box=${isDoubleBoxParam}&customer_id=${customerId}`;

      console.log("[DailyMenuDataService] Making API call:", apiUrl);

      const response: any = await this.apiService.get(apiUrl).toPromise();
      // const response: any = this.dummyData;

      console.log("[DailyMenuDataService] API response received:", {
        hasResponse: !!response,
        hasData: !!response?.data,
        hasMenuBuilders: !!response?.data?.menu_builders,
        menuBuildersCount: response?.data?.menu_builders?.length || 0,
        fullResponse: response,
      });

      if (response?.data?.menu_builders) {
        return response.data.menu_builders;
      }

      console.warn("[DailyMenuDataService] No menu_builders in response");
      return null;
    } catch (error) {
      console.error(
        "[DailyMenuDataService] Error fetching menu builders:",
        error,
      );
      throw error;
    }
  }

  getSelectedItemsForDate(date: string, isDoubleBox: boolean = false): any[] {
    const cacheKey = this.getCacheKey(date, isDoubleBox);
    const cached = this.cacheService.get<any>(cacheKey, "daily-menu");

    if (!cached || !cached.newNestedArray) {
      return [];
    }

    const selectedItems: any[] = [];

    cached.newNestedArray.forEach((group: any) => {
      group.type_data?.forEach((item: any) => {
        if (item.quantity > 0) {
          selectedItems.push({
            ...item,
            type_name: group.type_name,
            a_type_name: group.a_type_name,
            food_type_id: group.food_type_id,
          });
        }

        // Also check replaceable items
        item.replaceable_menu_items?.forEach((replaceable: any) => {
          if (replaceable.quantity > 0) {
            selectedItems.push({
              ...replaceable,
              type_name: group.type_name,
              a_type_name: group.a_type_name,
              food_type_id: group.food_type_id,
            });
          }
        });
      });
    });

    return selectedItems;
  }

  getGroupedMenuForDate(date: string, isDoubleBox: boolean = false): any[] {
    const cacheKey = this.getCacheKey(date, isDoubleBox);
    const cached = this.cacheService.get<any>(cacheKey, "daily-menu");

    if (!cached || !cached.newNestedArray) {
      return [];
    }

    return cached.newNestedArray;
  }
}
